import request from '@/utils/request'

/**
 * 查询家政服务列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAdminServ(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.queryAdminServ',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询家政服务类型
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingType(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingType.queryHousekeepingType',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}